import { Subscription } from 'rxjs';

function compose(...fns) {
    return function(...args) {
        return fns.reduceRight((previousValue, currentValue) => currentValue.apply(this, args), args);
    };
}

/**
 *  Can be use in components with @SubscriptionCollector
 *
 *  Example
 *  @Component(...)
 *  export class dummy {
 *      @SubscriptionCollector() mySub;
 *
 *      ngOnInit() {
 *          this.mySub = Observable.interval(2000).subscribe(
 *              _ => console.log('works');
 *          );
 *      }
 *  }
 */
export function SubscriptionCollector(key?: string) {
    return (target: object, propertyName: string) => {
        const subsMap = new Map();
        const _key = key || propertyName;

        function unsubscribe() {
            this[_key].forEach((sub) => sub.unsubscribe());
            subsMap.delete(this);
        }

        Object.defineProperty(target, _key, {
            configurable: false,
            get: function() {
                const subs = subsMap.get(this);
                if (!subs) {
                    subsMap.set(this, []);
                }
                return subsMap.get(this);
            },
            set: function(newSub) {
                this[_key].push(newSub);
            }
        });

        const old = target['ngOnDestroy'] || (() => null);
        Object.defineProperty(target, 'ngOnDestroy', {
            configurable: false,
            get: function() {
                return compose(
                    unsubscribe,
                    old
                ).bind(this);
            }
        });
    };
}
